import {
  Link,
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import "./App.css";
import HomePage from "./home/HomePage";
import MakesPage from "./makes/MakesPage";
import MakeMappingsPage from "./makeMappings/MakeMappingsPage";
import VehicleFilesPage from "./vehicleFiles/VehicleFilesPage";
import VehicleFileDetailsPage from "./vehicleFiles/VehicleFileDetailsPage";
import { useAuth } from "react-oidc-context";
import SignIn from "./common/SignIn";
import ProtectedRoute from "./common/ProtectedRoute";
import { authUtils } from "./common/authUtils";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import FilesForUpdatePage from "./releases/FilesForUpdatePage";
import ReleaseHistoryPage from "./releases/ReleaseHistoryPage";
import ReleaseDetailsPage from "./releases/ReleaseDetailsPage";
import Sidebar from "react-bootstrap-sidebar-menu";
import "./styles.scss";
import {
  CarFront,
  ClockHistory,
  FileEarmark,
  FileEarmarkText,
  Map,
  Rocket,
  ListUl,
  JournalX,
  ListColumns,
  ListColumnsReverse,
  ListCheck,
  Truck,
  CalendarEvent,
  ArrowRepeat,
} from "react-bootstrap-icons";
import "react-datetime/css/react-datetime.css";
import DefaultTemplateTextPage from "./defaultTemplateText/DefaultTemplateTextPage";
import DefaultTemplateTextTypesPage from "./defaultTemplateTextTypes/DefaultTemplateTextTypesPage";
import VehicleFileHistoryPage from "./vehicleFiles/VehicleFileHistoryPage";
import { configurationHelper } from "./configurationHelper";
import GlossaryTextExceptionPage from "./glossaryTextException/GlossaryTextExceptionPage";
import TemplateEditPage from "./drawings/TemplateEditPage";
import UpdateReportPage from "./reports/UpdateReportPage";
import StandardTextStringPage from "./glossaryStandardTextString/StandardTextStringPage";
import AttributeTextStringPage from "./glossaryAttributeTextString/AttributeTextStringPage";
import DrawingTemplatesPage from "./drawings/DrawingTemplatesPage";
import CreateUpdatePage from "./releases/CreateUpdatePage";
import BodyStylesPage from "./bodyStyles/BodyStylesPage";
import NumberPlateRequestPage from "./vis/NumberPlateRequestPage";
import YearlyOverviewVehicleFilePage from "./vehicleFiles/YearlyOverviewVehicleFilePage";
import YearlyOverviewDetailsPage from "./vehicleFiles/YearlyOverviewDetailsPage";
import EnvironmentSyncPage from "./releases/EnvironmentSyncPage";
import { Image } from "react-bootstrap";

const NavBarWrapper = () => {
  const auth = useAuth();

  const isAdmin = authUtils.isAdministrator(auth);
  const isUser = authUtils.isUser(auth);

  return (
    <div className="App main-wrapper">
      <Navbar className="main-header" expand="lg" bg="light" variant="light">
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            CRS Builder NT
            {configurationHelper.isDevelopment() && (
              <span
                style={{
                  paddingLeft: "10px",
                  color: "red",
                  textShadow: "blue 0 0 2px",
                }}
              >
                DEV
              </span>
            )}
            {configurationHelper.isTesting() && (
              <span
                style={{
                  paddingLeft: "10px",
                  color: "red",
                  textShadow: "blue 0 0 2px",
                }}
              >
                TEST
              </span>
            )}
            {configurationHelper.isStaging() && (
              <span
                style={{
                  paddingLeft: "10px",
                  color: "red",
                  textShadow: "blue 0 0 2px",
                }}
              >
                STAGING
              </span>
            )}
          </Navbar.Brand>
          <span style={{ position: "absolute", right: 0 }}>
            <SignIn />
          </span>
        </Container>
      </Navbar>
      <Sidebar variant="light" bg="light" expand="sm">
        <Sidebar.Collapse getScrollValue={100}>
          <Sidebar.Header>
            <Sidebar.Brand>
              <Image
                style={{ maxWidth: "150px" }}
                src="/bliksund_logo_horizontal.png"
                alt="bliksund logo"
              />
            </Sidebar.Brand>
            <Sidebar.Toggle />
          </Sidebar.Header>
          <Sidebar.Body>
            <Sidebar.Nav>
              {isAdmin && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Makes</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link as={Link} to="/makes">
                      <Sidebar.Nav.Icon>
                        <CarFront />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Makes</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    <Sidebar.Nav.Link as={Link} to="/makeMappings">
                      <Sidebar.Nav.Icon>
                        <Map />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Make Mappings</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Releases</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link as={Link} to="/releases/update">
                      <Sidebar.Nav.Icon>
                        <Rocket />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Files for Update</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    <Sidebar.Nav.Link as={Link} to="/releases/history">
                      <Sidebar.Nav.Icon>
                        <ClockHistory />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Release History</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    {isAdmin && (
                      <Sidebar.Nav.Link as={Link} to="/releases/create">
                        <Sidebar.Nav.Icon>
                          <ListCheck />
                        </Sidebar.Nav.Icon>
                        <Sidebar.Nav.Title>Create Update</Sidebar.Nav.Title>
                      </Sidebar.Nav.Link>
                    )}
                    {isAdmin && !configurationHelper.isProduction() && (
                      <Sidebar.Nav.Link as={Link} to="/releases/sync">
                        <Sidebar.Nav.Icon>
                          <ArrowRepeat />
                        </Sidebar.Nav.Icon>
                        <Sidebar.Nav.Title>Sync Environment</Sidebar.Nav.Title>
                      </Sidebar.Nav.Link>
                    )}
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Nav.Link as={Link} to="/vehicleFiles">
                  <Sidebar.Nav.Icon>
                    <FileEarmark />
                  </Sidebar.Nav.Icon>
                  <Sidebar.Nav.Title>Vehicle Files</Sidebar.Nav.Title>
                </Sidebar.Nav.Link>
              )}
              {isUser && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Template Texts</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link as={Link} to="/templateTexts">
                      <Sidebar.Nav.Icon>
                        <FileEarmarkText />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Template Texts</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    <Sidebar.Nav.Link as={Link} to="/TemplateTextTypes">
                      <Sidebar.Nav.Icon>
                        <ListUl />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Text Types</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Glossary Texts</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link
                      as={Link}
                      to="glossary/glossaryAttributeTextStrings"
                    >
                      <Sidebar.Nav.Icon>
                        <ListColumns />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Attribute Texts</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    <Sidebar.Nav.Link
                      as={Link}
                      to="glossary/glossaryStandardTextStrings"
                    >
                      <Sidebar.Nav.Icon>
                        <ListColumnsReverse />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Title Texts</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                    <Sidebar.Nav.Link
                      as={Link}
                      to="glossary/glossaryTextExceptions"
                    >
                      <Sidebar.Nav.Icon>
                        <JournalX />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Text Exceptions</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Nav.Link as={Link} to="/bodyStyles">
                  <Sidebar.Nav.Icon>
                    <Truck />
                  </Sidebar.Nav.Icon>
                  <Sidebar.Nav.Title>Vehicle Body Styles</Sidebar.Nav.Title>
                </Sidebar.Nav.Link>
              )}
              {isAdmin && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Drawings</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link as={Link} to="/drawings/templates">
                      <Sidebar.Nav.Icon>
                        <FileEarmarkText />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Templates</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Sub>
                  <Sidebar.Sub.Toggle>
                    <Sidebar.Nav.Icon />
                    <Sidebar.Nav.Title>Reports</Sidebar.Nav.Title>
                  </Sidebar.Sub.Toggle>
                  <Sidebar.Sub.Collapse>
                    <Sidebar.Nav.Link as={Link} to="/reports/updateReport">
                      <Sidebar.Nav.Icon>
                        <FileEarmarkText />
                      </Sidebar.Nav.Icon>
                      <Sidebar.Nav.Title>Update Report</Sidebar.Nav.Title>
                    </Sidebar.Nav.Link>
                  </Sidebar.Sub.Collapse>
                </Sidebar.Sub>
              )}
              {isUser && (
                <Sidebar.Nav.Link as={Link} to="/numberPlates">
                  <Sidebar.Nav.Icon>
                    <FileEarmark />
                  </Sidebar.Nav.Icon>
                  <Sidebar.Nav.Title>Number Plates</Sidebar.Nav.Title>
                </Sidebar.Nav.Link>
              )}
              {isUser && (
                <Sidebar.Nav.Link as={Link} to="/yearlyOverview">
                  <Sidebar.Nav.Icon>
                    <CalendarEvent />
                  </Sidebar.Nav.Icon>
                  <Sidebar.Nav.Title>Yearly overview</Sidebar.Nav.Title>
                </Sidebar.Nav.Link>
              )}
            </Sidebar.Nav>
          </Sidebar.Body>
        </Sidebar.Collapse>
      </Sidebar>
      <Outlet />
    </div>
  );
};

const router = createBrowserRouter([
  {
    element: <NavBarWrapper />,
    children: [
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
      {
        path: "/response-oidc/*",
      },
      {
        path: "/releases/history/:name",
        element: (
          <ProtectedRoute>
            <ReleaseDetailsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/releases/history",
        element: (
          <ProtectedRoute>
            <ReleaseHistoryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/releases/update",
        element: (
          <ProtectedRoute>
            <FilesForUpdatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/releases/create",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <CreateUpdatePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/releases/sync",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            {!configurationHelper.isProduction() && <EnvironmentSyncPage />}
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehicleFiles/details/:number",
        element: (
          <ProtectedRoute>
            <VehicleFileDetailsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehicleFiles/history/:number",
        element: (
          <ProtectedRoute>
            <VehicleFileHistoryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehicleFiles/:name",
        element: (
          <ProtectedRoute>
            <VehicleFilesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/vehicleFiles",
        element: (
          <ProtectedRoute>
            <VehicleFilesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/makeMappings",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <MakeMappingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/makes",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <MakesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/templateTexts",
        element: (
          <ProtectedRoute requiredRole={authUtils.User}>
            <DefaultTemplateTextPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/templateTextTypes",
        element: (
          <ProtectedRoute requiredRole={authUtils.User}>
            <DefaultTemplateTextTypesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "glossary/glossaryAttributeTextStrings",
        element: (
          <ProtectedRoute requiredRole={authUtils.User}>
            <AttributeTextStringPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "glossary/glossaryStandardTextStrings",
        element: (
          <ProtectedRoute requiredRole={authUtils.User}>
            <StandardTextStringPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "glossary/glossaryTextExceptions",
        element: (
          <ProtectedRoute requiredRole={authUtils.User}>
            <GlossaryTextExceptionPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/drawings/templates",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <DrawingTemplatesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/drawings/templates/create",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <TemplateEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/drawings/templates/edit/:name",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <TemplateEditPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/reports/updateReport",
        element: (
          <ProtectedRoute>
            <UpdateReportPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/bodyStyles",
        element: (
          <ProtectedRoute requiredRole={authUtils.Administrator}>
            <BodyStylesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/numberPlates",
        element: (
          <ProtectedRoute>
            <NumberPlateRequestPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/yearlyOverview",
        element: (
          <ProtectedRoute>
            <YearlyOverviewVehicleFilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/yearlyOverview/reviewableDetails/:makeCode",
        element: (
          <ProtectedRoute>
            <YearlyOverviewDetailsPage />
          </ProtectedRoute>
        ),
      },
      { path: "/", element: <HomePage /> },
      { path: "*", element: <Root /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}

function Root() {
  return <></>;
}
